import { CustomFormControl } from './styles';
import { MediaQuerys } from '../../styles/GlobalStyle';
import { CustomSelect, CustomSelectInput } from '../../pages/styles';
const { desktop } = MediaQuerys ;

export const SelectField = ({ onChange, value, label, options, isPlotplan }) => {

    return (
        <CustomFormControl isPlotplan={isPlotplan}>
            <CustomSelect
                size={ desktop ? 'small' : null }
                id="combo-box-demo"
                disableClearable
                defaultValue={value.nodePath}
                value={value.nodePath || null}
                onChange={(_, value) => {
                    let selected = options.filter((obj) => value === obj.nodePath)
                    if (selected[0].id) onChange(selected[0])
                }}
                placeholder={label}
                options={options.map((obj) => {return obj.nodePath})}
                sx={{ width: '100%' }}
                renderInput={(params) => <CustomSelectInput {...params} label={""}/>}
            />
        </CustomFormControl>
    )
}

